var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 1.5V2.55C9.25 2.97004 9.25 3.18006 9.16825 3.34049C9.09635 3.48161 8.98161 3.59635 8.84049 3.66825C8.68006 3.75 8.47004 3.75 8.05 3.75H5.95C5.52996 3.75 5.31994 3.75 5.15951 3.66825C5.01839 3.59635 4.90365 3.48161 4.83175 3.34049C4.75 3.18006 4.75 2.97004 4.75 2.55V1.5M4.15 16.5H9.85C10.6901 16.5 11.1101 16.5 11.431 16.3365C11.7132 16.1927 11.9427 15.9632 12.0865 15.681C12.25 15.3601 12.25 14.9401 12.25 14.1V3.9C12.25 3.05992 12.25 2.63988 12.0865 2.31901C11.9427 2.03677 11.7132 1.8073 11.431 1.66349C11.1101 1.5 10.6901 1.5 9.85 1.5H4.15C3.30992 1.5 2.88988 1.5 2.56901 1.66349C2.28677 1.8073 2.0573 2.03677 1.91349 2.31901C1.75 2.63988 1.75 3.05992 1.75 3.9V14.1C1.75 14.9401 1.75 15.3601 1.91349 15.681C2.0573 15.9632 2.28677 16.1927 2.56901 16.3365C2.88988 16.5 3.30992 16.5 4.15 16.5Z",
    stroke: "black",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccess);
export default __webpack_public_path__ + "static/media/Access.b6591ae9fceb526f9fd18fbfcce84709.svg";
export { ForwardRef as ReactComponent };